import { render, staticRenderFns } from "./view6.vue?vue&type=template&id=92523b90&scoped=true"
import script from "./view6.vue?vue&type=script&lang=js"
export * from "./view6.vue?vue&type=script&lang=js"
import style0 from "./view6.vue?vue&type=style&index=0&id=92523b90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92523b90",
  null
  
)

export default component.exports